// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2ea2T","alertIcon":"ConfirmModal_alertIcon__2hz2F"};